module.exports = __webpack_public_path__ + "static/media/mj.1ff00078.jpeg";